// src/components/layout/Footer.jsx
import React from "react";

function Footer({ copyrightText }) {
  if (!copyrightText) {
    return (
      <footer className="bg-black text-white text-center p-6 mt-auto">
        <p>© {new Date().getFullYear()} All rights reserved.</p>
      </footer>
    );
  }
  return (
    <footer className="bg-black text-white text-left p-6 mt-auto">
      <p>{copyrightText}</p>
    </footer>
  );
}

export default Footer;
